import { useReturnPage } from "hooks/useReturnPage";
import React from "react";
import { TextWithIconButton } from "components/parts/Button/TextWithIconButton";
import { TextWithIconTypes } from "components/parts/Button/TextWithIconButton/TextWithIconButton";
import styled from "styled-components";

export const BackButton: React.FC<{ className?: string }> = () => {
  const { getPageNameToReturn, returnPage } = useReturnPage();

  return (
    <>
      {getPageNameToReturn() && (
        <StyledBackButton
          text={`${getPageNameToReturn()}に戻る`}
          onClick={returnPage}
          iconName={TextWithIconTypes.NavigateBefore}
          variant="white"
          className="ipc_header"
        />
      )}
    </>
  );
};

const StyledBackButton = styled(TextWithIconButton)`
  margin-right: auto;
  height: 2rem;
`;
